import { permissions } from "../mock/permissions";

export const hasPermission = (role, permission) => {
  return permissions[role]?.includes(permission);
};
